import React from 'react';
import { BringzzOverlay, BringzzIcon, BringzzText } from '@bringzz/components';

const LoadingOverlay = ({ message = 'Processing your image...' }) => {
    return (
        <BringzzOverlay>
            <div className="flex flex-col items-center justify-center h-full">
                <div className="animate-spin mb-4">
                    <BringzzIcon
                        size="32"
                        icon="IconSpinner"
                        folder="LineIcons"
                        className="text-white"
                    />
                </div>
                <BringzzText tag="h3" className="text-white">
                    {message}
                </BringzzText>
            </div>
        </BringzzOverlay>
    );
};

export default LoadingOverlay;
